
// import React, { useState, useEffect } from 'react';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import {
//     Card,
//     Row,
//     Col,
//     CardTitle,
//     CardBody,
//     Button,
//     Form,
//     FormGroup,
//     Label,
//     Input,
//     FormText,
//     Table
// } from "reactstrap";
// import { useDispatch, useSelector } from 'react-redux';



// function UserProfileMaster() {

//   const navigate = useNavigate();
//   const [UserProfileTable, setUserProfileTable] = useState([]);

//   const getUserProfileData = async (page = 1, limit = 10, search = "") => {
//       try {
//           let config = {
//               headers: {
//                   'Content-Type': 'application/json', // Important for file upload//s
//                   'accept': 'application/json'
//               }
//           };

//           const response = await apiService.get(`api/admin/User_Detail/GetUserProfile?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
//           if (response.response && response.response.data.errors) {
//               toast.error(response.response?.data?.errors);
//           }

//           if (response.status === true) {
//               setUserProfileTable(response.user_Profile_Masters)
//               // toast.success(response.message);
//           }
//           else {
//               toast.error(response.message);
//           }
//       } catch (error) {
//           console.log(error)
//            toast.error(`SomeThing went wrong!!`);
//       }
//   };

//   const onHandleSearchKeyTask = (e) => {
//     const value = e.target.value;
//     getUserProfileData(1, 10, value)
//   }

//   const onHandleAddUserProfile = () => {
//     navigate("/adduserProfile")
//   }

//   const onHandleEditUserProfile = (UserProfileId) => {
//     navigate("/adduserProfile", { state: { userId: UserProfileId } })
//   }

//   const onHandleDeleteUserProfile = async (id) => {

//       const isDeleteConfirmed = window.confirm('Are you sure you want to delete this UserProfile?');
//       if (isDeleteConfirmed) {
//           try {
//               let config = {
//                   headers: {
//                       'Content-Type': 'application/json', 
//                       'accept': 'application/json'
//                   }
//               };

//               const response = await apiService.delete(`api/admin/User_Detail/DeleteUserProfileRole?id=${id}`, config)
//               if (response.response && response.response.data.errors) {
//                   toast.error(response.response?.data?.errors);
//               }

//               if (response.status === true) {
//                   toast.success(response.message);
//                   getUserProfileData()
//               }
//               else {
//                   toast.error(response.message);
//               }
//           } catch (error) {
//               console.log(error)
//                toast.error(`SomeThing went wrong!!`);
//           }
//       } else {
//           console.log('Deletion canceled.');
//       }
//   };

//   useEffect(() => {
//       getUserProfileData();
//   }, []);


//   return (
//       <Col lg="12">
//           <Card className='bg-white pd-10 card-box mb-30'>
//               <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
//                   <div className="d-flex align-items-center">
//                       <i className="bi bi-card-text mr-2"></i>
//                       User Profile Master
//                   </div>

//                   <Row className="align-items-center" style={{ marginRight: '10px', width: '300px' }}>
//                       <Input   id="search" name="search" placeholder="Search..." type="text" onChange={(e) => { onHandleSearchKeyTask(e) }} />
//                   </Row>

//                   <Button color="primary" size="bg"
//                       onClick={onHandleAddUserProfile}
//                   >Add</Button>
//               </CardTitle>

//               <CardBody className="">
//                   <Table striped hover responsive>
//                       <thead>
//                           <tr>
//                               <th>S.No.</th>
//                               {/* <th>User Profile</th> */}
//                               {/* <th>Company Owner Code</th> */}
//                               <th>Actions</th>
//                               <th>Role</th>
//                               <th>Creation Type</th>
//                           </tr>
//                       </thead>
//                       <tbody>
//                           {UserProfileTable.map((UserProfile, index) => (
//                               <tr key={index}>
//                                   <td>{index + 1}</td>
//                                   <td>
//                                      <i style={{cursor:"pointer"}} className="bi bi-pencil text-primary mr-3" onClick={() => onHandleEditUserProfile(UserProfile.id)}></i>

//  <i onClick={() => onHandleDeleteUserProfile(UserProfile.id)} style={{cursor:"pointer"}} className="bi bi-trash text-danger"></i>
                                 
//                                   </td>
//                                   {/* <td>{UserProfile.UserProfile_date.split('T')[0]}</td> */}
//                                   <td>{UserProfile.user_profile}</td>
//                                   <td>{UserProfile.creation_type}</td>
//                                   {/* <td>
//                                       <Button color="success" onClick={() => onHandleEditUserProfile(UserProfile.id)}><i className="bi bi-pencil text-primary" style={{cursor:"pointer"}}></i></Button>
//                                   </td> */}
//                                   <td>
//                                      </td>
//                               </tr>
//                           ))}
//                       </tbody>
//                   </Table>
//               </CardBody>
//           </Card>
//       </Col>
//   )
// }

// export default UserProfileMaster
//SignalR
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Input,
  Table
} from 'reactstrap';
import {
  createAppConnection,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

function UserProfileMaster() {
  const navigate = useNavigate();
  const [UserProfileTable, setUserProfileTable] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const mountedRef = useRef(false);

  const getUserProfileData = useCallback(async (page = 1, limit = 10, search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json'
        }
      };

      const response = await apiService.get(
        `api/admin/User_Detail/GetUserProfile?pageNo=${page}&limit=${limit}&searchKey=${encodeURIComponent(search)}`,
        config
      );

      if (response.response && response.response.data?.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setUserProfileTable(response.user_Profile_Masters || []);
      } else {
        setUserProfileTable([]);
        toast.error(response.message || 'Failed');
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
      setUserProfileTable([]);
    }
  }, []);

  const onHandleSearchKeyTask = (e) => {
    const value = e.target.value;
    setSearchKey(value);
    getUserProfileData(1, 10, value);
  };

  const onHandleAddUserProfile = () => {
    navigate('/adduserProfile');
  };

  const onHandleEditUserProfile = (UserProfileId) => {
    navigate('/adduserProfile', { state: { userId: UserProfileId } });
  };

  const onHandleDeleteUserProfile = async (id) => {
    const isDeleteConfirmed = window.confirm('Are you sure you want to delete this UserProfile?');
    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json'
          }
        };

        const response = await apiService.delete(
          `api/admin/User_Detail/DeleteUserProfileRole?id=${id}`,
          config
        );

        if (response.response && response.response.data?.errors) {
          toast.error(response.response?.data?.errors);
        }

        if (response.status === true) {
          toast.success(response.message);
          getUserProfileData(1, 10, searchKey);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.log(error);
        toast.error('SomeThing went wrong!!');
      }
    }
  };

  useEffect(() => {
    getUserProfileData(1, 10, searchKey);
  }, [getUserProfileData, searchKey]);

  useEffect(() => {
    mountedRef.current = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mountedRef.current || !payload) return;

          const isSameModule = String(payload.module || '') === 'UserProfileMaster';

          if (isSameModule) {
            getUserProfileData(1, 10, searchKey);
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    setupSignalR();

    return () => {
      mountedRef.current = false;
    };
  }, [getUserProfileData, searchKey]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();
    };
  }, []);

  return (
    <Col lg="12">
      <Card className='bg-white pd-10 card-box mb-30'>
        <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="bi bi-card-text mr-2"></i>
            User Profile Master
          </div>

          <Row className="align-items-center" style={{ marginRight: '10px', width: '300px' }}>
            <Input
              id="search"
              name="search"
              placeholder="Search..."
              type="text"
              value={searchKey}
              onChange={onHandleSearchKeyTask}
            />
          </Row>

          <Button color="primary" size="bg" onClick={onHandleAddUserProfile}>
            Add
          </Button>
        </CardTitle>

        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Actions</th>
                <th>Role</th>
                <th>Creation Type</th>
              </tr>
            </thead>
            <tbody>
              {UserProfileTable.length > 0 ? (
                UserProfileTable.map((UserProfile, index) => (
                  <tr key={UserProfile.id ?? index}>
                    <td>{index + 1}</td>
                    <td>
                      <i
                        style={{ cursor: 'pointer' }}
                        className="bi bi-pencil text-primary mr-3"
                        onClick={() => onHandleEditUserProfile(UserProfile.id)}
                      ></i>

                      <i
                        onClick={() => onHandleDeleteUserProfile(UserProfile.id)}
                        style={{ cursor: 'pointer' }}
                        className="bi bi-trash text-danger"
                      ></i>
                    </td>
                    <td>{UserProfile.user_profile}</td>
                    <td>{UserProfile.creation_type}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">No data found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </Col>
  );
}

export default UserProfileMaster;













